export const URL_DOWNLOAD_APP_STORE =
  'https://apps.apple.com/id/app/oxone-online/id1570010379';

export const URL_DOWNLOAD_PLAY_STORE =
  'https://play.google.com/store/apps/details?id=com.oxoneonline';
